import React from 'react';
import variables from '../../../utils/variables';
import * as PropTypes from 'prop-types';
import './index.css';
import { Button } from '@material-ui/core';
import Icon from '../../../components/Icon';
import logo1 from '../../../assets/dApps/Studio.jpg';
import logo2 from '../../../assets/dApps/Market.jpg';
import logo3 from '../../../assets/dApps/TV.jpg';
import logo4 from '../../../assets/dApps/Insync.jpg';
import logo5 from '../../../assets/dApps/StreamPay.jpg';
import logo6 from '../../../assets/dApps/ME.png';
import logo7 from '../../../assets/dApps/logo7.svg';

const DApps = (props) => {
    const handleRedirect = (link) => {
        window.open(link, '_blank');
    };

    return (
        <section className="d_apps" id="dApps">
            <div className="heading">
                <h2>{variables[props.lang]['dApps_ecosystem']}</h2>
                <span/>
                {/* <p>{variables[props.lang]['dApps_ecosystem_info']}</p> */}
            </div>
            <div className="info_rows">
                <div className="row">
                    <div className="text_info">
                        <h2>{variables[props.lang]['omniflix_studio']}</h2>
                        <p>{variables[props.lang]['dApps_ecosystem_test1']}</p>
                        <Button
                            className="secondary_button"
                            variant="outlined"
                            onClick={() => handleRedirect('https://app.omniflix.studio')}>
                            <p>{variables[props.lang]['explore_studio']}</p>
                            <Icon className="arrow" icon="arrow"/>
                        </Button>
                    </div>
                    <img alt={variables[props.lang]['omniflix_studio']} src={logo1}/>
                </div>
                <div className="row">
                    <div className="text_info">
                        <h2>{variables[props.lang].omniflix_marketplace}</h2>
                        <p>{variables[props.lang]['dApps_ecosystem_test2']}</p>
                        <Button
                            className="secondary_button"
                            variant="outlined"
                            onClick={() => handleRedirect('https://omniflix.market')}>
                            <p>{variables[props.lang]['visit_omniflix_market']}</p>
                            <Icon className="arrow" icon="arrow"/>
                        </Button>
                    </div>
                    <img alt={variables[props.lang]['omniflix_nucleus']} src={logo2}/>
                </div>
                <div className="row">
                    <div className="text_info">
                        <h2>{variables[props.lang]['omniflix_tv']}</h2>
                        <p>{variables[props.lang]['dApps_ecosystem_test3']}</p>
                        <Button
                            className="secondary_button"
                            variant="outlined"
                            onClick={() => handleRedirect('https://omniflix.tv')}>
                            <p>{variables[props.lang]['run_a_channel']}</p>
                            <Icon className="arrow" icon="arrow"/>
                        </Button>
                    </div>
                    <img alt={variables[props.lang]['omniflix_tv']} src={logo3}/>
                </div>
                <div className="row">
                    <div className="text_info">
                        <h2>{variables[props.lang]['omniflix_insync']}</h2>
                        <p>{variables[props.lang]['dApps_ecosystem_insync']}</p>
                        <Button
                            className="secondary_button"
                            variant="outlined"
                            onClick={() => handleRedirect('https://omniflix.co/home')}>
                            <p>{variables[props.lang]['explore_insync']}</p>
                            <Icon className="arrow" icon="arrow"/>
                        </Button>
                    </div>
                    <img alt={variables[props.lang]['omniflix_tv']} src={logo4}/>
                </div>
                <div className="row">
                    <div className="text_info">
                        <h2>{variables[props.lang]['omniflix_streampay']}</h2>
                        <p>{variables[props.lang]['dApps_ecosystem_streampay']}</p>
                        <Button
                            className="secondary_button"
                            variant="outlined"
                            onClick={() => handleRedirect('https://streampay.me/')}>
                            <p>{variables[props.lang]['explore_streampay']}</p>
                            <Icon className="arrow" icon="arrow"/>
                        </Button>
                    </div>
                    <img alt={variables[props.lang]['omniflix_tv']} src={logo5}/>
                </div>
                <div className="row">
                    <div className="text_info">
                        <h2>{variables[props.lang]['omniflix_me']}</h2>
                        <p>{variables[props.lang]['dApps_ecosystem_test4']}</p>
                        <Button
                            disabled
                            className="secondary_button"
                            variant="outlined"
                            onClick={() => handleRedirect('https://docs.omniflix.network/stakeholders/creators')}>
                            <p>{variables[props.lang]['coming_soon'] + '...'} </p>
                            {/* <Icon className="arrow" icon="arrow"/> */}
                        </Button>
                    </div>
                    <img alt={variables[props.lang]['omniflix_me']} src={logo6}/>
                </div>
                <div className="row">
                    <div className="text_info">
                        <h2>{variables[props.lang]['cross_chain_assets']}</h2>
                        <p>{variables[props.lang]['dApps_ecosystem_test5']}</p>
                        <Button
                            className="secondary_button"
                            variant="outlined"
                            onClick={() => handleRedirect('https://docs.omniflix.network/stakeholders/developers')}>
                            <p>{variables[props.lang]['deploy_contracts_on_testnet']}</p>
                            <Icon className="arrow" icon="arrow"/>
                        </Button>
                    </div>
                    <img alt={variables[props.lang]['cross_chain_assets']} src={logo7}/>
                </div>
            </div>
        </section>
    );
};

DApps.propTypes = {
    lang: PropTypes.string.isRequired,
};

export default DApps;
